/* eslint-disable max-len */
const CalendarEventGraphic = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="7.31616" y="8.80005" width="25.6" height="25.6" rx="2" />
        <path d="M26.5162 5.6001V12.0001" />
        <path d="M13.7162 5.6001V12.0001" />
        <path d="M7.31616 18.4001H32.9162" />
        <rect x="13.7162" y="24.8" width="3.2" height="3.2" />
      </g>
    </svg>
  );
};

export default CalendarEventGraphic;
